import mitt, { Emitter } from 'mitt';

export type FunnelEvent =
    /** Next step event. Use hijackNextStep to hijack it. */
    | { name: 'nextStep' }

    /** Previous step event */
    | { name: 'prevStep' }

    /**
     * If uou're a funnel step and wants to hijack the next step for yourself,
     * use this event to let the funnel know it no longer owns the next step.
     *
     * You may emit the event again with mode: 'off' if necessary to disable it
     * during the step's life cycle, although it's not necessary as it's
     * automatically called before switching steps.
     */
    | { name: 'hijackNextStep'; payload: { mode: 'on' | 'off' } }

    /**
     * If you're a step inside a stepper and wishes to also be a stepper, you
     * can emit this event to let the funnel know that you hijacked the navigation.
     *
     * This allows us to:
     * - Nest a stepper inside a stepper infinitely, all while
     * maintaining the same flat funnel hierarchy eg.: [step1, step2, step3...]
     * where step3 might also be a stepper with it's own steps.
     *
     * - Have a single form component at the root, responsible for validation
     * and such.
     */
    | { name: 'hijackNavigation'; payload: { mode: 'on' | 'off' } };

type EventBusEvent = {
    login: any;
    connect_error: any;
    on_reconnect: any;
    tickUpdate: void;
    funnelEvent: FunnelEvent;
};

const emitter: Emitter<EventBusEvent> = mitt<EventBusEvent>();

export default function useEventBus() {
    return emitter;
}
